import moment from "moment";
import { loadValuesFromVector, prepareScenarioVectors } from '../utilities/SimulationVectors'
import { convertToPctArray } from '../utilities/ArrayUtils'

let requestBodies = {}

class BaseRequestBodyFactory {
  constructor(props, isSingle) {
    this.DealName = props.dealName
    this.SettlementDate = moment(props.settlementDate).format().split("T")[0].replace(/-/g, "")
    this.RunLoanLevel = props.runLoanLevel
    this.CleanupCall = props.cleanupCall
    this.UseMortgageInsurance = props.useMortgageInsurance;
    if ((props.selectedScenario == null || props.selectedScenario.type == 'scenario') && props.prepaymentModel == null) {
      let cpr, cdr, lossSeverity, delinquency
      ({cpr, cdr, lossSeverity, delinquency} = prepareScenarioVectors(props))
      if (isSingle) {
        this.Cpr = convertToPctArray(cpr);
        this.Cdr = convertToPctArray(cdr);
      } else {
        this.Cpr = props.cpr.filter(x => x !== "" && x != undefined).map(x => convertToPctArray(x))
        this.Cdr = props.cdr.filter(x => x !== "" && x != undefined).map(x => convertToPctArray(x))
      }

      this.LossSeverity = convertToPctArray(lossSeverity)
      this.Delinquency = convertToPctArray(delinquency)
      this.PrepaymentModel = "UserDefined"
    } else if (props.prepaymentModel.includes('LDM') || props.prepaymentModel == "AFT") {
      if (!isSingle) {
        throw { response: { data: { Message: "Matrix does not support prepayment models." } } }
      }
      if (props.mtg30 != "") { this.Mtg30Year = loadValuesFromVector(props.mtg30).toString().split(",") }
      if (props.mtg15 != "") { this.Mtg15Year = loadValuesFromVector(props.mtg15).toString().split(",") }
      if (props.prepaymentModel == "AFT") {
        if (props.hpa != "") { this.Hpa = loadValuesFromVector(props.hpa).toString().split(",") } 
      }
      if (props.prepaymentModel && props.prepaymentModel.includes &&  props.prepaymentModel.includes("LDM")) {
        if (props.hpi != "") { this.Hpi = loadValuesFromVector(props.hpi).toString().split(",") }
        if (props.prepaymentModel == 'LDM_3') {
          if (props.NationalUnemploymentForecast != "") { this.NationalUnemploymentForecast = loadValuesFromVector(props.NationalUnemploymentForecast).toString().split(",") }
        }
        if (props.twoYrTsy != "") { this.Tsy2Year = loadValuesFromVector(props.twoYrTsy).toString().split(",") }
        if (props.tenYrTsy != "") { this.Tsy10Year = loadValuesFromVector(props.tenYrTsy).toString().split(",") }
        if (props.tuneCpr != "") { this.TuneCpr = props.tuneCpr.toString().split(",")[0] }
        if (props.tuneCdr != "") { this.TuneCdr = props.tuneCdr.toString().split(",")[0] }
        if (props.tuneSeverity != "") { this.TuneSeverity = props.tuneSeverity.toString().split(",")[0] }
      }
      this.PrepaymentModel = props.prepaymentModel
    } else if (props.selectedScenario != null && props.selectedScenario.type == 'cashflow') {
      if (!isSingle) {
        throw { response: { data: { Message: "Matrix does not support prerun cashflows." } } }
      }
      this.UserCollateralCashflow = props.selectedScenario.data.CollateralCashflow
    } else {
      throw { response: { data: { Message: "Not supported scenario type." } } }
    }

    if (props.libor != undefined) { this.Libor = convertToPctArray(loadValuesFromVector(props.libor), false) }
  }
}

class BondRequestBodyFactory extends BaseRequestBodyFactory {
  constructor(props, isSingle) {
    super(props, isSingle);
    this.BondName = props.bondName
    Object.assign(this, props.specBody)
  }
}

class AcisRequestBodyFactory extends BaseRequestBodyFactory {
  constructor(props, isSingle) {
    super(props, isSingle);
    this.BondName = props.bondName
    this.OwnedFaceAmt = props.ownedFaceAmt
    this.Margin = props.margin
    this.Cancellation = props.cancellation
    this.InterestRate = props.interestRate
  }
}

class CirtRequestBodyFactory extends BaseRequestBodyFactory {
  constructor(props, isSingle) {
    super(props, isSingle);
    this.OwnedFaceAmt = props.ownedFaceAmt
    this.Margin = props.margin
    this.InterestRate = props.interestRate
    this.Cancellation = props.cancellation
    if (props.cancellation) { this.CancellationDate = moment(props.cancellationDate).format("YYYYMMDD") }
  }
}

requestBodies['BASE'] = BaseRequestBodyFactory;
requestBodies['BOND'] = BondRequestBodyFactory;
requestBodies['ACIS'] = AcisRequestBodyFactory;
requestBodies['CIRT'] = CirtRequestBodyFactory;

export default function RequestBodyFactory(type, props, isSingle = true) {
  let body = new requestBodies[type](props, isSingle);
  return body
}
